// Available policies configuration
// This will be fetched from backend in the future
export interface PolicyOption {
  id: string;
  name: string;
  description: string;
  customizations: {
    /** Initiator email allowlist → config.allowedEmailDomains */
    emails?: boolean;
    /** Dual-control: validators + required additional approvals */
    multiAuth?: boolean;
  };
}

export const AVAILABLE_POLICIES: PolicyOption[] = [
  {
    id: 'email-otp',
    name: 'Email OTP/Blind Signing Protection',
    description:
      'Require email-based one-time password verification and provide transaction insights for blind signing protection',
    customizations: {
      emails: true,
    },
  },
  {
    id: 'multi-email-otp',
    name: 'Multi-party email OTP',
    description:
      'Require the initiator to authenticate by email, then a set number of additional validators to approve before the transaction proceeds',
    customizations: {
      emails: true,
      multiAuth: true,
    },
  },
  {
    id: 'no-verification',
    name: 'No Verification',
    description: 'Allow the transaction to pass through without any verification',
    customizations: {},
  },
  // More policies will be added dynamically from backend
];

/** UI id or API type that uses an email allowlist for the primary user. */
export function isEmailAuthPolicyType(type: string | undefined): boolean {
  return (
    type === 'email-otp' ||
    type === 'multi-email-otp' ||
    type === 'UserAuthenticationPolicy' ||
    type === 'UserMultiAuthenticationPolicy' ||
    type === 'UserAuthenticationChecksDemoPolicy'
  );
}

export function isMultiAuthPolicyType(type: string | undefined): boolean {
  return type === 'multi-email-otp' || type === 'UserMultiAuthenticationPolicy';
}
